import { isValidEmail } from '@domain-group/javascript-utils'

const state = {
  agent_title: '',
  business_name: '',
  business_number: '',
  license_number: '',
  other_enquiry_email: '',
  profile: '',
}

// other_enquiry_email is not a required field but if present needs to be a valid email
export const requiredFields = [
  {
    invalidMessage: 'Invalid Email format',
    key: 'other_enquiry_email',
    validation: (email: string) => !email || isValidEmail(email),
  },
]

export default state
